module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAAFVBMVEVHcExwcHBwcHBwcHBwcHBwcHBwcHDnx2nMAAAABnRSTlMA0BC4YCAilMuQAAAAWElEQVQoz2NgGNKAOVkBTCsnQwXc0oRAFJNYmgNMIBGkRDENJsCYBlICVJAI1QJiKoAUCMFMBbEhokhKApEUgJWkISkAK0FRAFaCrACsRAjV+crJCoM8gAF31RLlE+QgjgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/views/couponsys/assets/images/icon_arrow.png
// module id = XIWP
// module chunks = 0